import { InView } from 'react-intersection-observer';
import style from '../knear.module.scss'
import animations from '@styles/animations.module.scss'

interface BenefitsSectionProps {
    title: string;
    points: Array<string>;
    colorGray: boolean;
}

const BenefitsSection = ({title, points, colorGray}: BenefitsSectionProps) => {
    return (
        // TODO: What could be the reason to have three containers fully embedded one inside of each other?
        <section className={`${style.section} ${colorGray ? style.section_gray : style.section_light}`}>
            <div className={`${style.container}`}>
                <div className={`${style.container__flex}`}>
                    <InView triggerOnce={true}>
                        {({inView, ref, entry}: any) => {
                            if (inView) {
                                entry?.target.classList.add(animations.active);
                            }
                            return (
                                <div ref={ref}
                                     className={`${style.container__list__title} ${style.container__title} ${style.container__title_left} ${animations.scroll__animation}`}>
                                    {title}
                                </div>
                            )
                        }}
                    </InView>
                    <div className={`${style.container__list}`}>
                        {points.map((item: any, index: number) => {
                            return (
                                <div className={style.container__list__points} key={index}>
                                    <InView triggerOnce={true}>
                                        {({inView, ref, entry}: any) => {
                                            if (inView) {
                                                entry?.target.classList.add(animations.active);
                                            }
                                            return (
                                                <div ref={ref}
                                                     className={`${style.container__points} ${animations.scroll__animation}`}>
                                                    {item}
                                                </div>
                                            )
                                        }}
                                    </InView>
                                </div>
                            )
                        })}
                    </div>
                </div>
            </div>
        </section>
    )
}

export default BenefitsSection;
